import styles from "./styles.module.css";
import { Dispatch, useEffect, useRef, useState } from "react";
import { SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as HamburgerSvg } from "../../../assets/navbericon/hamburger.svg";
import { ReactComponent as NotificationSvg } from "../../../assets/navbericon/notification1.svg";
import { ReactComponent as ProfileSvg } from "../../../assets/navbericon/profile.svg";
import { ReactComponent as ProfileLineSvg } from "../../../assets/navbericon/profileLine.svg";
import { ReactComponent as ProfileArrowSvg } from "../../../assets/navbericon/icon/more.svg";
import { ReactComponent as LogOutSvg } from "../../../assets/navbericon/icon/logout.svg";
import { ReactComponent as Logo } from "../../../assets/altlogo2.svg";
import { ReactComponent as SvgSearchIcon } from "../../../assets/navbericon/mobileSearch.svg";
import { ReactComponent as SearchIconWBorder } from "../../../assets/navbericon/searchIcon.svg";
import { ReactComponent as NotificationBellSvg } from "../../../assets/navbericon/notificationbell.svg";
import useMediaQuery from "../../../app/common/hooks/useMediaQuery";
import { useStore } from "../../../app/stores/store";
import { UserPermissions, UserProfile } from "../../../app/models/user";
import { observer } from "mobx-react-lite";
import agent from "../../../app/api/agent";

interface HeaderProps {
  user?: UserProfile;
  setOpen?: Dispatch<SetStateAction<boolean>>;
}

const Header = ({ user, setOpen = () => { } }: HeaderProps) => {
  const navigate = useNavigate();

  const matches = useMediaQuery("(min-width: 1290px)");

  const [profileModal, setProfileModal] = useState(false);
  const [notificationsModal, setNotificationsModal] = useState(false);
  const profileRef = useRef(null);
  const notificationRef = useRef(null);

  const [searchActive, setSearchActive] = useState(false);
  const { userStore } = useStore();
  const { notifications } = userStore;
  const { logout, getVendorNotifications } = userStore;

  useEffect(() => {
    getVendorNotifications();
  }, [getVendorNotifications]);



  return (
    <>
      <div className={styles.headerContainer}>
        {!matches ? (
          <>
            {/* <img src={logo} alt="" /> */}
            <Logo onClick={() => navigate("/")} />
            <div className={styles.flexHeaderSm}>
              <svg
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "30px", cursor: "pointer" }}
                ref={notificationRef}
                onClick={() => setNotificationsModal((state) => !state)}
              >
                <path
                  d="M3.6 8.45798V7.4C3.6 3.86538 6.46538 1 10 1C13.5346 1 16.4 3.86537 16.4 7.4V8.45798C16.4 10.7583 17.0649 13.0096 18.3146 14.9409L19 16H1L1.68539 14.9408C2.93512 13.0096 3.6 10.7583 3.6 8.45798Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 19.8887C9.5344 20.4825 10.4656 20.4825 11 19.8887"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {/* {searchActive ? (
                <div className={styles.searchBarSm}>
                  <input placeholder="Enter Keyword" />
                  <SvgSearchIcon className={styles.searchIcon} />
                </div>
              ) : (
                <button onClick={() => setSearchActive(true)}>
                  <SearchIconWBorder width={48} />
                </button>
              )} */}
              <button
                style={{ marginLeft: "7px" }}
                onClick={() => setOpen((state) => !state)}
              >
                <HamburgerSvg />
              </button>
            </div>
          </>
        ) : (
          <div className={`${styles.flexHeader}`}>
            {/* <div className={`${styles.searchBar}`}>
              <input placeholder="Enter Keyword" />

              <div className={styles.searchIcon}>
                <SearchIcon />
              </div>
            </div> */}
            {/* <NavLink to={`/vendor/dashboard`} style={{ marginRight: "50px" }}>
              {({ isActive }) => (
                <NotificationSvg
                  style={{ stroke: !isActive ? "#344437" : "#36b44a" }}
                  onClick={() => setNotificationsModal((state) => !state)}
                />
              )}
            </NavLink> */}
            {/* <NotificationSvg
              style={{ marginRight: "30px", cursor: "pointer" }}
              onClick={() => setNotificationsModal((state) => !state)}
            /> */}
            <div style={{ position: 'relative' }}>
              <svg
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: '30px', cursor: 'pointer' }}
                ref={notificationRef}
                onClick={() => setNotificationsModal((state) => !state)}
              >
                <path
                  d="M3.6 8.45798V7.4C3.6 3.86538 6.46538 1 10 1C13.5346 1 16.4 3.86537 16.4 7.4V8.45798C16.4 10.7583 17.0649 13.0096 18.3146 14.9409L19 16H1L1.68539 14.9408C2.93512 13.0096 3.6 10.7583 3.6 8.45798Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 19.8887C9.5344 20.4825 10.4656 20.4825 11 19.8887"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {/* Notification Count Badge */}
              {notifications.length > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-2px', // Position slightly above the bell
                    right: '2px', // Position slightly to the right of the bell
                    backgroundColor: 'red', // Badge color
                    color: 'white', // Text color
                    borderRadius: '50%',
                    width: '16px', // Badge size
                    height: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '10px', // Text size
                    fontWeight: 'bold',
                  }}
                >
                  {notifications.length}
                </div>
              )}
            </div>

            <ProfileSvg style={{ marginRight: "0px" }} />
            <h3 style={{ margin: "0px" }}>
              {user!.firstName} {user!.lastName}
            </h3>
            {/* <ProfileArrowSvg
              style={{ marginRight: "20px", cursor: "pointer" }}
              onClick={() => setProfileModal((state) => !state)}
            /> */}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: "20px", cursor: "pointer" }}
              ref={profileRef}
              onMouseUp={() => {
                setProfileModal(!profileModal);
              }}
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="#8F8F8F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <ProfileLineSvg
              style={{ marginRight: "30px" }}
              onClick={() => setProfileModal((state) => !state)}
            />

            <h3
              style={{
                margin: "0px",
                marginLeft: "10px",
                marginRight: "10px",
                fontWeight: "400",
              }}
            >
              Log Out
            </h3>
            <LogOutSvg
              style={{ marginRight: "20px", cursor: "pointer" }}
              onClick={() => logout()}
            />
          </div>
        )}
        <ProfileModal
          user={user}
          open={profileModal}
          setProfileModal={setProfileModal}
          profileRef={profileRef}
        />

        <NotificationModal
          open={notificationsModal}
          setNotificationsModal={setNotificationsModal}
          notificationRef={notificationRef}
        />
      </div>
    </>
  );
};
function useOutsideAlerter(
  ref: any,
  setProfileModal: (value: SetStateAction<boolean>) => void,
  profileRef: any
) {
  useEffect(() => {
    /**
     * close modal if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        // close modal;
        setProfileModal(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, profileRef, setProfileModal]);
}
const ProfileModal = ({
  user,
  open,
  setProfileModal,
  profileRef,
}: {
  user: any;
  open: boolean;
  setProfileModal: (value: SetStateAction<boolean>) => void;
  profileRef: React.MutableRefObject<null>;
}) => {
  const navigate = useNavigate();

  const { userStore, commonStore } = useStore();
  const { logout } = userStore;
  const { loggedInUser, isAuthorized } = commonStore;
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setProfileModal, profileRef);
  return (
    <>
      {open && (
        <div className={styles.modalContainer} ref={wrapperRef}>
          {/* <div className={styles.profileContainer}>
            <img src={profile} />
            <div className={styles.profileText}>
              <h3>{user.vendorProfileDto.companyName}</h3>
              <p>{user.vendorProfileDto.email}</p>
            </div>
          </div> */}
          <div className="divider" />
          {loggedInUser &&
            (isAuthorized(UserPermissions.viewOrders) ||
              isAuthorized(UserPermissions.settings)) && (
              <div className={styles.profileLinksContainer}>
                {isAuthorized(UserPermissions.settings) && (
                  <button onClick={() => navigate("/vendor/settings")}>
                    View Profile
                  </button>
                )}
                {isAuthorized(UserPermissions.viewOrders) && (
                  <button onClick={() => navigate("/vendor/orders")}>
                    View Orders
                  </button>
                )}
              </div>
            )}
          {/* <div className="divider" /> */}
          <div className={styles.logoutContainer}>
            <button onClick={logout}>Logout</button>
          </div>
        </div>
      )}
    </>
  );
};

const NotificationModal = ({
  open,
  setNotificationsModal,
  notificationRef,
}: {
  open: boolean;
  setNotificationsModal: (value: SetStateAction<boolean>) => void;
  notificationRef: React.MutableRefObject<null>;
}) => {
  const { userStore } = useStore();
  const { notifications } = userStore;
  const wrapperRef = useRef(null);
  const navigate = useNavigate()

  useOutsideAlerter(wrapperRef, setNotificationsModal, notificationRef);
  // useEffect(()=> {
  //   const payload = "kZn5JG0E8lKlnJ1oR8BgFFbG2gzd4foLjjWDmcyZUFdS8c5Mw6Zr2mwYhbdGDAzKxBhBFd9VYLWW+rvqpeHaMA=="
  //   console.log(agent.decryptResponse(payload));
  // }, [])

  const handleRedirect = (id: string) => {
    navigate("/vendor/products/details/" + id)
  }
  return (
    <>
      {open && (
        <div className={styles.notificationModalContainer} ref={wrapperRef}>
          <div className={styles.header}>Notifications</div>
          {notifications && notifications.length > 0 ? (
            notifications.map((notification, index) => {
              return (
                <div onClick={() => handleRedirect(notification.eventId)} className={styles.notificationBox} key={index}>
                  <div className={styles.bellBox}>
                    <NotificationBellSvg />
                  </div>
                  <div className={styles.infoBox}>
                    <div className={styles.title}>{notification.title}</div>
                    <div className={styles.details}>{notification.message}</div>
                  </div>
                  <div className={styles.notificationTime}>
                    {/* <div>12 Jun. 2023 | 12:39pm</div> */}
                  </div>
                </div>
              );
            })
          ) : (
            <div className={styles.noNotifications}>No Notifications Yet</div>
          )}
        </div>
      )}
    </>
  );
};

export default observer(Header);
